const TYPE = "familia";

const familiaProdutoModule = {
  findAll: async (dbConnection, limite = null) => {
    let familias = [];
    let result = await dbConnection.find({
      selector: {
        type: { $eq: TYPE },
        //status: { $eq: "A" },
      },
      limit: 9999
    });

    if (result.docs.length) {
      familias = result.docs;
    }

    return familias;
  },
};

export default familiaProdutoModule;
